'use strict';
import utils from "./utils/utils.js";
import "./common.js";
import "./campaign.js";
import "../_scss/studio_detail.scss";
import axios from "axios";

((w, d) => {})(window, document);